import { gql } from "@apollo/client";

export const LIST_PAYMENT_METHODS_QUERY = gql`
  query listPaymentMethods($filter: PaymentMethodFilter, $limit: Int, $offset: Int) {
    listPaymentMethods(filter: $filter) {
      results(limit: $limit, offset: $offset) {
        id
        code
        name
      }
      totalCount
    }
  }
`;

export const GET_PAYMENT_METHOD_QUERY = gql`
  query getPaymentMethod($id: ID!) {
    getPaymentMethod(id: $id) {
      id
      code
      name
      order
    }
  }
`;

export const CREATE_PAYMENT_METHOD = gql`
  mutation createPaymentMethod($input: CreatePaymentMethodInput!) {
    createPaymentMethod(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const UPDATE_PAYMENT_METHOD = gql`
  mutation updatePaymentMethod($input: UpdatePaymentMethodInput!) {
    updatePaymentMethod(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const GET_VATS_LIST_BY_COMPANY = gql`
  query listVatsPaginated($filter: VatFilter, $limit: Int, $offset: Int, $orderBy: [String]) {
    listVatsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        rate
        code
        remotePk: code
        counterPartBuy {
          id
          name
          remotePk
          __typename
        }
        counterPartSell {
          id
          name
          remotePk
          __typename
        }
        counterPartImmobilization {
          id
          name
          remotePk
          __typename
        }
        autoLiquidation
        __typename
        cycle {
          startDate
          endDate
        }
        isActive
      }
      __typename
    }
  }
`;

export const CREATE_VAT = gql`
  mutation createVat($input: CreateVatInput!) {
    createVat(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_VAT = gql`
  mutation updateVat($input: UpdateVatInput!) {
    updateVat(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const GET_CLIENTS_LIST_BY_COMPANY = gql`
  query listClientsPaginated($filter: ClientFilter, $limit: Int, $offset: Int, $orderBy: [String]) {
    listClientsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        name
        shortName
        siren: vatNumber
        code
        counterPart {
          name
          code
        }
        vat {
          id
          rate
          code
        }
        isActive
        cycle {
          id
          startDate
          endDate
        }
      }
    }
  }
`;

export const LIST_VAT_QUERY = gql`
  query listVatsPaginated($filter: VatFilter) {
    listVatsPaginated(filter: $filter) {
      results(limit: 0) {
        id
        rate
        code
        bookTypeFilter
      }
    }
  }
`;

export const LIST_VAT_QUERY_ASYNC_SELECT = gql`
  query listVatsPaginated($filter: VatFilter, $limit: Int, $offset: Int) {
    listVatsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset) {
        id
        rate
        code
      }
    }
  }
`;

export const GET_VAT = gql`
  query getVat($id: ID!) {
    getVat(id: $id) {
      id
      rate
      code
      remotePk: code
      showInCaisse
      isActive
      counterPartBuy {
        id
        name
        remotePk
      }
      counterPartSell {
        id
        name
        remotePk
      }
      counterPartImmobilization {
        id
        name
        remotePk
      }
      allocationSellCounterpart {
        id
        name
        remotePk
      }
      allocationBuyCounterpart {
        id
        name
        remotePk
      }
      autoLiquidation
      cycle {
        startDate
        endDate
        id
      }
      autoLiquidationVat {
        id
        code
        rate
      }
    }
  }
`;

export const LIST_COUNTRIES_QUERY = gql`
  query listCountriesPaginated($search: String, $limit: Int, $offset: Int) {
    listCountriesPaginated(filter: { name_Unaccent_Istartswith: $search }) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: "name") {
        code
        name
      }
    }
  }
`;

export const DELETE_AFFECTATION = gql`
  mutation ($id: ID!) {
    deleteAssignment(id: $id) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const LIST_SUBSIDIARIES = gql`
  query listSubsidiaries($filter: SubsidiaryFilter, $limit: Int, $offset: Int, $orderBy: [String]) {
    listSubsidiaries(filter: $filter) {
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        code
        id
        name
        description
        cycle {
          startDate
          endDate
        }
      }
      totalCount
    }
  }
`;

export const LIST_CYCLES = gql`
  query listCyclesPaginated($filter: CycleFilter, $limit: Int, $offset: Int, $orderBy: [String]) {
    listCyclesPaginated(filter: $filter) {
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        startDate
        endDate
        limitDate
        isActive
        id
        totalBooks
      }
      totalCount
    }
  }
`;

export const GET_CYCLE = gql`
  query getCycle($id: ID!) {
    getCycle(id: $id) {
      id
      startDate
      endDate
      limitDate
      isActive
      inUse
    }
  }
`;

export const CREATE_CYCLE = gql`
  mutation createCycle($input: CreateCycleInput!) {
    createCycle(input: $input) {
      errors {
        field
        messages
      }
      success
      cycle {
        id
        startDate
        endDate
      }
    }
  }
`;

export const UPDATE_CYCLE = gql`
  mutation updateCycle($input: UpdateCycleInput!) {
    updateCycle(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const DELETE_CYCLE = gql`
  mutation deleteCycle($id: ID!) {
    deleteCycle(id: $id) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const COPY_ACCOUNTING_TO_NEW_CYCLE = gql`
  mutation copyAccountingsToNewCycle($input: CopyAccountingsToNewCycleInput!) {
    copyAccountingsToNewCycle(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;
